import React, { useState } from "react";
import { Container, Row, Col, Card, Button, Modal } from "react-bootstrap";
import "./gallery.css";

import img1 from "../assets/gallery/images/1.jpeg";
import img2 from "../assets/gallery/images/2.jpeg";
import img3 from "../assets/gallery/images/3.jpeg";
import img4 from "../assets/gallery/images/4.jpeg";
import img5 from "../assets/gallery/images/5.jpeg";
import img6 from "../assets/gallery/images/6.jpeg";
import img7 from "../assets/gallery/images/7.jpeg";
import img8 from "../assets/gallery/images/8.jpeg";
import img9 from "../assets/gallery/images/9.jpeg";
import img10 from "../assets/gallery/images/10.jpeg";
import img11 from "../assets/gallery/images/11.jpeg";
import img12 from "../assets/gallery/images/12.jpeg";
import img13 from "../assets/gallery/images/13.jpeg";
import img14 from "../assets/gallery/images/14.jpeg";
import img15 from "../assets/gallery/images/15.jpeg";
import img16 from "../assets/gallery/images/16.jpeg";
import img17 from "../assets/gallery/images/17.jpeg";

const galleryData = [
  { id: 1, category: "Events", img: img1, title: "Legal Awareness Event" },
  { id: 2, category: "Events", img: img2, title: "Community Outreach" },
  {
    id: 3,
    category: "Conferences",
    img: img3,
    title: "National Law Conference",
  },
  { id: 4, category: "Conferences", img: img4, title: "Advocacy Summit" },
  { id: 5, category: "Workshops", img: img5, title: "Legal Training Workshop" },
  { id: 6, category: "Workshops", img: img6, title: "Youth Advocacy Program" },
  { id: 7, category: "Conferences", img: img7, title: "Satyug Program" },
  {
    id: 8,
    category: "Conferences",
    img: img8,
    title: "Youth Advocacy Program",
  },
  { id: 9, category: "Workshops", img: img9, title: "Youth Advocacy Program" },
  {
    id: 10,
    category: "Workshops",
    img: img10,
    title: "Youth Advocacy Program",
  },
  {
    id: 11,
    category: "Workshops",
    img: img11,
    title: "Youth Advocacy Program",
  },
  // {
  //   id: 12,
  //   category: "Workshops",
  //   img: img12,
  //   title: "Youth Advocacy Program",
  // },
  {
    id: 13,
    category: "Workshops",
    img: img13,
    title: "Youth Advocacy Program",
  },
  {
    id: 14,
    category: "Workshops",
    img: img14,
    title: "Youth Advocacy Program",
  },
  {
    id: 15,
    category: "Workshops",
    img: img15,
    title: "Youth Advocacy Program",
  },
  // {
  //   id: 16,
  //   category: "Workshops",
  //   img: img16,
  //   title: "Youth Advocacy Program",
  // },
  {
    id: 17,
    category: "Workshops",
    img: img17,
    title: "Youth Advocacy Program",
  },
];

const Gallery = () => {
  const [filter, setFilter] = useState("All");

  // 👉 NEW STATES
  const [show, setShow] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const filteredImages =
    filter === "All"
      ? galleryData
      : galleryData.filter((item) => item.category === filter);

  // 👉 OPEN MODAL
  const handleShow = (index) => {
    setCurrentIndex(index);
    setShow(true);
  };

  const handleClose = () => setShow(false);

  // 👉 NEXT / PREV
  const nextImage = () => {
    setCurrentIndex((prev) =>
      prev === filteredImages.length - 1 ? 0 : prev + 1,
    );
  };

  const prevImage = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? filteredImages.length - 1 : prev - 1,
    );
  };

  return (
    <>
      {/* BANNER */}
      <div className="gallery-banner d-flex align-items-center bg-dark">
        <Container>
          <h1 className="text-white">Our Gallery</h1>
          <p className="text-light">
            Moments from our events, conferences & initiatives
          </p>
        </Container>
      </div>

      <Container className="py-5">
        {/* FILTER */}
        <div className="text-center mb-4">
          {["All", "Events", "Conferences", "Workshops"].map((cat) => (
            <Button
              key={cat}
              className={`mx-2 gallery-filter-btn ${
                filter === cat ? "active" : ""
              }`}
              onClick={() => setFilter(cat)}
            >
              {cat}
            </Button>
          ))}
        </div>

        {/* GRID */}
        <Row>
          {filteredImages.map((item, index) => (
            <Col md={4} sm={6} className="mb-4" key={item.id}>
              <Card
                className="gallery-card"
                onClick={() => handleShow(index)}
                style={{ cursor: "pointer" }}
              >
                <div className="gallery-img-wrapper">
                  <Card.Img src={item.img} />
                  <div className="gallery-overlay">
                    {/* <h5>{item.title}</h5>
                    <span>{item.category}</span> */}
                  </div>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      {/* 🔥 MODAL SLIDER */}
      <Modal show={show} onHide={handleClose} centered size="lg">
        <Modal.Body className="text-center position-relative">
          {/* PREV */}
          <button className="nav-btn left" onClick={prevImage}>
            ❮
          </button>

          {/* IMAGE */}
          <img
            src={filteredImages[currentIndex]?.img}
            alt=""
            className="img-fluid"
            style={{ maxHeight: "80vh" }}
          />

          {/* NEXT */}
          <button className="nav-btn right" onClick={nextImage}>
            ❯
          </button>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Gallery;
